module.exports = __webpack_public_path__ + "static/media/control-panel-white.01cd62ef.svg";